<template lang="pug">
	.audio-tracker--wapi-plugins-manager(v-if="plugins")
		Popup(v-if="popupVisible", ref="popup", :popupVisible="popupVisible", :title="$tCaption('Effects manager')", classes="tracker-dark", :width="960", :height="260", :closeOnOutsideClick="true", @hiding="v => popupVisible = false")
			.audio-tracker--wapi-plugins-manager.flex-col.space-large.align-center.center
				.adder.flex-row.center.align-center(v-if="activePluginsList.length === 0")
					DxButton(icon="plus", stylingMode="text", @click="initAddItem(0)")
				Container.flex-row.space.wrap.plugins-list(v-if="activePluginsList.length", orientation="horizontal", @drop="onEffectDrop", :get-ghost-parent="getGhostParent", group-name="plugins")
					Draggable.audio-tracker--wapi-plugins-manager--effect(v-for="(f,i) in activePluginsList", :key="f.instance.instanceId")
						.flex-row.center.align-center
							.adder.flex-row.center.align-center(v-if="i === 0")
								DxButton(icon="plus", stylingMode="text", @click="initAddItem(0)")
							.effect-item.flex-row.space.align-center
								.effect-name.flex-row.align-center(:class="{ inactive: !f.instance.enabled }")
									.effect-enabler.flex-col.center.align-center(@click="toggleInstanceEnabled(f.instance)")
										fas(:icon="f.instance.enabled ? 'check' : 'link-slash'", size="lg")
									.name.nowrap(@click="openPlugin(f)") {{f.plugin.name()}}
								DxButton(icon="close", @click="removePlugin(i)")
							.adder.flex-row.center.align-center
								DxButton(icon="plus", stylingMode="text", @click="initAddItem(i + 1)")
			template(slot="actions-left")
				DxButton(v-if="activePluginsList.length", :text="hasEnabledPlugins ? $tCaption('Bypass all') : $tCaption('Enable all')", @click="toggleBypass", type="normal", :icon="hasEnabledPlugins ? 'fas fa-volume-xmark' : 'fas fa-volume-high'")
			template(slot="actions-right")
				DxButton(:text="!tracker.isPlaying ? $tCaption('Play', '@actions') : $tCaption('Stop', '@actions')", type="default", :icon="tracker.isPlaying ? 'square' : 'fas fa-play'", @click="tracker.togglePlay()")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
		Popup(v-if="addItemPopupVisible", ref="addItemPopup", :popupVisible="addItemPopupVisible", classes="tracker-dark", :width="380", :height="420", :closeOnOutsideClick="true", @hiding="v => addItemPopupVisible = false")
			.flex-col.space
				.new-effect-item.flex-row.justify(v-for="plugin in availablePlugins")
					span {{plugin.name()}}
					DxButton(:text="$tCaption('Add', '@actions')", type="normal", @click="addPlugin(plugin)")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="addItemPopupVisible = false")
</template>

<script>
	import VueTypes from 'vue-types';
	import pluginsList from './plugins-list';
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import { Container, Draggable } from 'vue-smooth-dnd';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker--wapi-plugins-manager',
		components: { Popup, DxButton, Container, Draggable, DxCheckBox },
		props: {
			plugins: VueTypes.any.def(null),
			tracker: VueTypes.any.def(null)
		},
		model: {
			prop: 'plugins',
			event: 'change'
		},
		data() {
			return {
				popupVisible: false,
				addItemPopupVisible: false,
				addItemIndex: null
			};
		},
		computed: {
			activePluginsList() {
				return this.plugins.map(f => ({
					instance: f,
					plugin: pluginsList.plugins.find(p => p.id === f.id),
					id: f.id
				})).filter(f => f.plugin)
			},
			availablePlugins() {
				return pluginsList.plugins;
			},
			hasEnabledPlugins() {
				return this.activePluginsList.some(f => f?.instance?.enabled);
			}
		},
		watch: {

		},
		mounted() {
		},
		destroyed() {

		},
		methods: {
			toggleBypass() {
				let val = !this.hasEnabledPlugins;
				this.activePluginsList.map(f => f.instance.enabled = val);
			},
			toggleInstanceEnabled(instance) {
				instance.enabled = !instance.enabled;
				this.tracker.refreshPlay();
			},
			openPlugin(plugin) {
				if (__DEBUG__)
					console.debug('Open plugin', { plugin });
				this.$emit('open', plugin);
			},
			removePlugin(idx) {
				this.$confirmMessage({
					title: this.$tCaption('Please confirm action', '@actions'),
					text: this.$tCaption('Do you want to remove this effect?'),
					buttons: [{
						text: this.$tCaption('Yes', '@actions'),
						onClick: (e) => {
							this.plugins.splice(idx, 1)
						}
					}, {
						text: this.$tCaption('Cancel', '@actions')
					}]
				});
			},
			initAddItem(idx) {
				this.addItemPopupVisible = false;
				this.addItemIndex = idx;
				setImmediate(() => {
					this.addItemPopupVisible = true;
				})
			},
			addPlugin(plugin) {
				this.addItemPopupVisible = false;
				this.plugins.splice(this.addItemIndex, 0, {
					id: plugin.id,
					enabled: true,
					data: null,
					instanceId: this.$Data.uuid()
				})
			},
			show() {
				if (__DEBUG__)
					window.wapiPluginsManager = this;

				this.popupVisible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.popupVisible = true;
				})
			},
			onEffectDrop(e) {
				var movingItem = this.plugins[e.removedIndex];
				if (movingItem && e.addedIndex > -1) {
					this.plugins.splice(e.removedIndex, 1);
					this.plugins.splice(e.addedIndex, 0, movingItem);
					this.tracker.refreshPlay();
				}
			},
			getGhostParent() {
				return document.body;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker--wapi-plugins-manager {
		.plugins-list {
			height: 70px;
		}
	}

	.audio-tracker--wapi-plugins-manager--effect {
		.effect-item {
			background: rgba(0,0,0,0.1);
			padding: 10px 10px 10px 15px;
			border-radius: 10px;

			.effect-name {
				cursor: pointer !important;
				color: $base-accent;

				&.inactive {
					color: rgba(255,255,255,0.2);
				}
			}

			.effect-enabler {
				cursor: pointer !important;
				padding: 4px;
				border-radius: 40px;
				width: 30px;
				height: 30px;

				&:hover {
					background: rgba(0,0,0,0.1);
				}
			}
		}

		&.smooth-dnd-ghost {
			z-index: 10000 !important;

			.adder {
				display: none;
			}
		}

		.adder {
			width: 60px;
		}
	}
</style>
